const Config = {
    resumeLink: 'https://drive.google.com/file/d/1q-EiIG0FdPP8A48quUfoQutrKP8H1XvN/view?usp=sharing',
    twitterLink: 'https://www.x.com',
    linkedinLink:'https://www.linkedin.com/in/uiuxdesignerjunaid/',
    whatsapp:'https://wa.me/971589789768'

  };
  
  export default Config;